export interface Role {
    name: string;
}

export namespace RoleEnum {
    export enum Role {
        Administrator = 'Administrator',
        UserManager = 'UserManager',
        Tester = 'Tester',
        Analyst = 'Analyst',
    }

    export const ROLE_LIST: string[] = [
        Role.Administrator,
        Role.UserManager,
        Role.Tester,
        Role.Analyst,
    ];
}
